import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import api from 'mastodon/api';
import { unfollowAccount, muteAccount, blockAccount } from 'mastodon/actions/accounts';
import { Button } from 'mastodon/components/button';
import Thanks from 'mastodon/features/report/thanks';

const ReportSensitiveModal = ({
  statusId,
  accountId,
  account,
  onClose,
  onChangeBackgroundColor,
  dispatch,
  onReportSuccess,
}) => {
  const intl = useIntl();
  const [reportSent, setReportSent] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    onChangeBackgroundColor('rgba(0, 0, 0, 0.7)');
    return () => onChangeBackgroundColor(null);
  }, [onChangeBackgroundColor]);

  const handleReport = () => {
    api()
      .post('/api/v1/reports', {
        account_id: accountId,
        status_ids: [statusId],
        comment: '',
        category: 'spam',
        forward: false,
        forward_to_domains: [],
      })
      .then(() => {
        setReportSent(true);
        if (onReportSuccess) {
          onReportSuccess(); // Call the callback to notify parent of success
        }
      })
      .catch((err) => {
        setError(err.message || intl.formatMessage({
          id: 'report_sensitive.error',
          defaultMessage: 'Failed to report content. Please try again.',
        }));
      });
  };

  return (
    <div className={classNames('modal-root__modal', 'report-sensitive-modal')}>
      <div className={classNames('report-sensitive-modal-container', {
        'report-sensitive-modal-container--expanded': reportSent,
      })}>
        <div className="report-sensitive-modal__header">
          <h3>{intl.formatMessage({
            id: 'report_sensitive.header',
            defaultMessage: 'Report',
          })}</h3>
          <button
            className="report-sensitive-modal__close"
            onClick={onClose}
            title={intl.formatMessage({
              id: 'report_sensitive.cancel',
              defaultMessage: 'Cancel',
            })}
          >
            ✕
          </button>
        </div>
        {reportSent ? (
          <div className="report-dialog-modal__container">
            <Thanks
              account={account}
              submitted={true}
              onSubmit={() => {}}
              onClose={onClose}
              dispatch={dispatch}
            />
          </div>
        ) : (
          <div className="report-sensitive-modal__content">
            {error ? (
              <p className="error">{error}</p>
            ) : (
              <div className="report-container">
                <div className="text-line">
                  <span>{intl.formatMessage({
                    id: 'report_sensitive.text',
                    defaultMessage: 'Are you sure you want to report this content?',
                  })}</span>
                </div>
                <div className="final-line">
                  <button className="action-button" onClick={onClose}>
                    {intl.formatMessage({
                      id: 'report_sensitive.cancel',
                      defaultMessage: 'Cancel',
                    })}
                  </button>
                  <button className="action-button action-button--confirm" onClick={handleReport}>
                    {intl.formatMessage({
                      id: 'report_sensitive.confirm',
                      defaultMessage: 'Confirm',
                    })}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

ReportSensitiveModal.propTypes = {
  statusId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  account: ImmutablePropTypes.record.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeBackgroundColor: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  onReportSuccess: PropTypes.func, // New prop for callback
};

const mapStateToProps = (state, ownProps) => ({
  account: state.getIn(['accounts', ownProps.accountId]),
});

export default connect(mapStateToProps)(ReportSensitiveModal);